import { atom } from "jotai";

export const startDateFilterAtom = atom<string | undefined>(undefined);
export const timeOfDayFilterAtom = atom<
  | {
      timeGTE?: string;
      timeLTE?: string;
    }
  | undefined
>(undefined);
export const lessonTypeFilterAtom = atom<
  { id: string; defaultDuration: number } | undefined
>(undefined);
